import type { TrackedTranslation } from '@ps/web-core-intl';
import { Toggle } from '@ps/web-shared-components';
import React from 'react';

export interface OptionToggle {
  id: string;
  value: string;
  label: TrackedTranslation;
}

export interface OptionToggleClasses {
  wrapper?: string;
  toggle?: string;
}

export type TOnChange = (options: OptionToggle[], checked: boolean) => void;

export interface MultipleSelectToggleProps extends OptionToggle {
  onChange?: TOnChange;
  disabled?: boolean;
  classes?: OptionToggleClasses;
  checked?: boolean;
  id: string;
  description?: React.ReactNode;
}

const MultipleSelectToggle: React.FC<MultipleSelectToggleProps> = ({
  id,
  label,
  value,
  onChange,
  classes,
  checked,
  description
}) => (
  <div className={classes?.wrapper}>
    <Toggle
      onChange={(e) => onChange?.([{ label, value, id }], e.target.checked)}
      id={id}
      type="checkbox"
      label={label}
      className={classes?.toggle}
      checked={checked}
    />
    {description}
  </div>
);
export default MultipleSelectToggle;
